/* eslint-disable camelcase */
bcl.c.cancelationModal = {
  props: {
    cancelationModalSelector: ".JS-cancelationModal",
    cancelReservationBtnSelector: ".JS-cancel-reservation-btn",
    callmeBtnSelector: ".JS-callme-btn",
    closeModalBtnSelector: ".JS-tingle-modal__close",
    activeModalClass: "tingle-modal--visible",
    modalTitleSelector: ".JS-modalTitle",
    modalTitlePlaceholder: "@hotelName",
    reasonModalContainerSelector: ".JS-reasons-modal-cont",
    cancelatiolCallMeFormSelector: ".JS-cancelation-callme",
    reasonsProps: {
      reasonsSelectSelector: ".JS-reasons-select",
      reasonsContainerSelector: ".JS-reasons",
      doubtSelector: ".reason-doubts",
      changeSelecot: ".reason-change",
      betterSelector: ".reason-better",
      cancelationSelector: ".reason-cancelation",
      noneSelector: ".reason-none",
    },
    callMeFormProps: {
      callMeFormBtnSelector: ".JS-cancelation-callme-button-send",
      callMeSuccessSelector: ".JS-cancelation-callme-success",
      callMeNameInputName: "cancelation-callme-name",
      callMeSurNameInputName: "cancelation-callme-surname",
      callMeTelInputName: "cancelation-callme-tel",
      callMePolicyInputName: "cancelation-callme-policy",
      enableButtonClass: "mod--disabled",
      invalidClass: "mod--invalidate",
      EVENT: "cancellation_outbound_call",
    },
    hidden: "hidden",
  },
  init: function () {
    const modals = document.querySelectorAll(bcl.c.cancelationModal.props.cancelationModalSelector);
    modals.forEach((modal) => {
      if (modal) {
        bcl.c.cancelationModal.initModal(modal);
      }
    });
  },
  replacePlaceholder: function (modal) {
    const title = modal.querySelector(bcl.c.cancelationModal.props.modalTitleSelector);
    // eslint-disable-next-line camelcase, no-undef
    if (title && title.innerHTML.indexOf(bcl.c.cancelationModal.props.modalTitlePlaceholder) >= 0 && typeof utag !== "undefined" && window.utag_data["hotel_name"]) {
      // eslint-disable-next-line camelcase, no-undef
      title.innerHTML = title.innerHTML.replace(bcl.c.cancelationModal.props.modalTitlePlaceholder, window.utag_data["hotel_name"]);
    }
  },
  initModal: function (modal) {
    const props = bcl.c.cancelationModal.props;
    bcl.c.cancelationModal.replacePlaceholder(modal);
    //first content load
    const reasonsProps = props.reasonsProps,
      select = modal.querySelector(reasonsProps.reasonsSelectSelector),
      reasonsContainer = modal.querySelector(reasonsProps.reasonsContainerSelector);
    if (select && reasonsContainer) {
      bcl.c.cancelationModal.changeContent(select, reasonsContainer);
      bcl.c.cancelationModal.initModalListeners(modal, select, reasonsContainer);
    }
  },
  closeModal: function (modal) {
    if (modal.classList.contains(bcl.c.cancelationModal.props.activeModalClass)) {
      const reasonsModalContainer = modal.querySelector(bcl.c.cancelationModal.props.reasonModalContainerSelector);
      if (reasonsModalContainer) {
        if (reasonsModalContainer.classList.contains(bcl.c.cancelationModal.props.hidden)) {
          reasonsModalContainer.classList.remove(bcl.c.cancelationModal.props.hidden);
          bcl.c.cancelationModal.hideCallMeForm(modal);
        }
      }
      modal.classList.remove(bcl.c.cancelationModal.props.activeModalClass);
    }
  },
  showChild: function (child) {
    if (child.classList.contains(bcl.c.cancelationModal.props.hidden)) {
      child.classList.remove(bcl.c.cancelationModal.props.hidden);
    }
  },
  hideChild: function (child) {
    if (!child.classList.contains(bcl.c.cancelationModal.props.hidden)) {
      child.classList.add(bcl.c.cancelationModal.props.hidden);
    }
  },
  changeContent: function (select, reasonsContainer) {
    const children = reasonsContainer.querySelectorAll('[class*="reason"]'),
      value = select.value;
    children.forEach((child) => {
      if (child.classList.contains(value)) {
        bcl.c.cancelationModal.showChild(child);
      } else {
        bcl.c.cancelationModal.hideChild(child);
      }
    });
  },
  showCallForm: function (modal) {
    const form = modal.querySelector(bcl.c.cancelationModal.props.cancelatiolCallMeFormSelector),
      reasonsModalContainer = modal.querySelector(bcl.c.cancelationModal.props.reasonModalContainerSelector);
    if (form && reasonsModalContainer) {
      if (!reasonsModalContainer.classList.contains(bcl.c.cancelationModal.props.hidden)) {
        reasonsModalContainer.classList.add(bcl.c.cancelationModal.props.hidden);
        form.classList.remove(bcl.c.cancelationModal.props.hidden);
      }
    }
  },
  closeModalListener: function (modal) {
    const btn = modal.querySelector(bcl.c.cancelationModal.props.closeModalBtnSelector);
    if (btn) {
      btn.addEventListener("click", () => {
        bcl.c.cancelationModal.closeModal(modal);
      });
    }
  },
  callMeListener: function (modal) {
    const btns = modal.querySelectorAll(bcl.c.cancelationModal.props.callmeBtnSelector);
    btns.forEach((btn) => {
      if (btn) {
        btn.addEventListener("click", () => {
          bcl.c.cancelationModal.showCallForm(modal);
        });
      }
    });
  },
  selectOnChangeListener: function (select, reasonsContainer) {
    select.addEventListener("change", () => {
      bcl.c.cancelationModal.changeContent(select, reasonsContainer);
    });
  },
  cancelReservation: function (modal) {
    bcl.c.cancelationModal.closeModal(modal);
  },
  cancelReservationListener: function (modal) {
    const btns = modal.querySelectorAll(bcl.c.cancelationModal.props.cancelReservationBtnSelector);
    btns.forEach((btn) => {
      if (btn) {
        btn.addEventListener("click", () => {
          const selectElement = document.querySelector(".c-cancelation__modal-reasons__selector.JS-reasons-select");
          const selectedValue = selectElement.value;

          if (selectedValue === "reason-cancelation") {
            window.utag.link({ tealium_event: "cancel_no_outbound_call", isoc_cancel_reason: "reason-cancelled-trip" });
          }
          if (selectedValue === "reason-none") {
            window.utag.link({ tealium_event: "cancel_no_outbound_call", isoc_cancel_reason: "reason-none-above" });
          }
          if (selectedValue === "reason-doubts") {
            window.utag.link({ tealium_event: "cancel_no_outbound_call", isoc_cancel_reason: "reason-doubts" });
          }
          if (selectedValue === "reason-change") {
            window.utag.link({ tealium_event: "cancel_no_outbound_call", isoc_cancel_reason: "reason-change" });
          }
          if (selectedValue === "reason-better") {
            window.utag.link({ tealium_event: "cancel_no_outbound_call", isoc_cancel_reason: "reason-better" });
          }
          bcl.c.cancelationModal.cancelReservation(modal);
        });
      }
    });
  },
  sendFormButtonListener: function (modal, props) {
    const btns = modal.querySelectorAll(props.callMeFormBtnSelector);
    if (btns && btns.length > 0) {
      btns.forEach((buttonSend) => {
        buttonSend.addEventListener("click", function () {
          if (bcl.c.cancelationModal.validateCallMeBackForm(modal, props)) {
            //enable button
            buttonSend.classList.remove(props.enableButtonClass);
            //send data via utag
            const objToSend = {
              // eslint-disable-next-line camelcase
              tealium_event: props.EVENT,
              // eslint-disable-next-line camelcase, no-undef
              isoc_hotel_name: window.widgetIS.bookingHotel,
              // eslint-disable-next-line camelcase, no-undef
              isoc_number_rooms: window.widgetIS.bookingRoomQuantity,
              // eslint-disable-next-line camelcase, no-undef
              isoc_number_adults: window.widgetIS.bookingAdults,
              // eslint-disable-next-line camelcase, no-undef
              isoc_number_children: window.widgetIS.bookingChildren,
              // eslint-disable-next-line camelcase, no-undef
              isoc_quotation_amount: window.widgetIS.bookingPrice,
              // eslint-disable-next-line camelcase, no-undef
              isoc_room_type: window.widgetIS.bookingRoomType,
              // eslint-disable-next-line camelcase, no-undef
              isoc_rate_type: window.widgetIS.bookingRateName,
              // eslint-disable-next-line camelcase, no-undef
              isoc_check_in_date: window.widgetIS.bookingCheckIn,
              // eslint-disable-next-line camelcase, no-undef
              isoc_check_out_date: window.widgetIS.bookingCheckOut,
              // eslint-disable-next-line camelcase, no-undef
              isoc_room_details: window.widgetIS.bookingBoardBasis,
              // eslint-disable-next-line camelcase, no-undef
              isoc_number_nights: window.widgetIS.bookingNights,
              // eslint-disable-next-line camelcase
              isoc_first_name: modal.querySelector("input[name=" + props.callMeNameInputName + "]").value,
              // eslint-disable-next-line camelcase
              isoc_last_name: modal.querySelector("input[name=" + props.callMeSurNameInputName + "]").value,
              // eslint-disable-next-line camelcase
              user_phone: modal.querySelector(".iti__selected-flag")?.title?.split(":")[1]?.replace(" ", "") + modal.querySelector("input[name=" + props.callMeTelInputName + "]").value,
              // eslint-disable-next-line camelcase, no-undef
              isoc_user_email: window.widgetIS.emailAddress,
              // eslint-disable-next-line camelcase
              isoc_opt_in_date: bcl.c.callMeBackForm.getDateToSendFormatted(),
              // eslint-disable-next-line camelcase
              isoc_call_time: modal.querySelector("input[type=radio][name=cancelation-callme-time]:checked").value,
              // eslint-disable-next-line camelcase, no-undef
              isoc_currency: window.widgetIS.bookingCurrency,
              // eslint-disable-next-line camelcase, no-undef
              isoc_booking_itinerary: window.widgetIS.bookingItinerary,
              // eslint-disable-next-line camelcase, no-undef
              isoc_itinerary_number: window.widgetIS.bookingItineraryNumber,
              // eslint-disable-next-line camelcase
              isoc_cancel_reason: modal.querySelector(".JS-reasons-select").value,
            };
            if (typeof utag !== "undefined") {
              // eslint-disable-next-line no-undef
              window.utag.link(objToSend);
            }
            //into success AJAX
            bcl.c.cancelationModal.showSuccessSendModalCallMeBack(modal, props);
            bcl.c.cancelationModal.hideCallMeForm(modal);
          }
        });
      });
    }
  },
  showSuccessSendModalCallMeBack: function (modal, props) {
    const divSuccess = modal.querySelector(props.callMeSuccessSelector);
    if (divSuccess) {
      divSuccess.classList.remove(bcl.c.cancelationModal.props.hidden);
    }
  },
  hideCallMeForm: function (modal) {
    const form = modal.querySelector(bcl.c.cancelationModal.props.cancelatiolCallMeFormSelector);
    if (form) {
      form.classList.add(bcl.c.cancelationModal.props.hidden);
    }
  },
  termsOnChangeCallMeBack: function (modal, props) {
    const terms = modal.querySelector("input[name=" + props.callMePolicyInputName + "]"),
      buttonSend = modal.querySelector(props.callMeFormBtnSelector);
    if (terms && buttonSend) {
      terms.addEventListener("change", function () {
        if (terms.checked) {
          buttonSend.classList.remove(props.enableButtonClass);
        } else {
          buttonSend.classList.add(props.enableButtonClass);
        }
      });
    }
  },

  telOnChangeCallMeBack: function () {
    const input = document.querySelector("#cancelation-callme-input-contact-tel");
    if (input != null) {
      const iti = window.intlTelInputGlobals.getInstance(input);
      input.addEventListener("countrychange", function () {
        const dialCode = iti.getSelectedCountryData().dialCode;
        const dialCodeText = document.querySelector(".JS-cancelation-callme .JS-contact-tel-prefix");
        dialCodeText.textContent = "+ " + dialCode + " |";
        if (dialCode.length == 1) {
          bcl.u.removeClass(input, "pl-68");
          bcl.u.addClass(input, "pl-50");
        } else if (dialCode.length == 2) {
          bcl.u.removeClass(input, "pl-50");
          bcl.u.removeClass(input, "pl-68");
        } else if (dialCode.length == 3) {
          bcl.u.removeClass(input, "pl-50");
          bcl.u.addClass(input, "pl-68");
        }
      });
    }
  },
  validateCallMeBackForm: function (modal, callMeProps) {
    let valid = true;

    const nameInput = modal.querySelector("input[name=" + callMeProps.callMeNameInputName + "]"),
      surnameInput = modal.querySelector("input[name=" + callMeProps.callMeSurNameInputName + "]"),
      phoneInput = modal.querySelector("input[name=" + callMeProps.callMeTelInputName + "]");

    if (nameInput.value === "") {
      valid = false;
      bcl.c.cancelationModal.addInvalidClass(nameInput);
    }
    if (surnameInput.value === "") {
      valid = false;
      bcl.c.cancelationModal.addInvalidClass(surnameInput);
    }
    if (phoneInput.value === "" || !bcl.c.cancelationModal.validatePhone(phoneInput) || phoneInput.classList.contains(bcl.c.cancelationModal.props.callMeFormProps.invalidClass)) {
      valid = false;
      bcl.c.cancelationModal.addInvalidClass(phoneInput);
    }
    const terms = modal.querySelector("input[name=" + callMeProps.callMePolicyInputName + "]");
    if (!terms.checked) {
      valid = false;
    }
    return valid;
  },
  addInvalidClass: function (el) {
    if (el) {
      el.classList.add(bcl.c.cancelationModal.props.callMeFormProps.invalidClass);
    }
  },
  validatePhone: function ($input) {
    if ($input) {
      const instance = window.intlTelInputGlobals.getInstance($input);
      return instance.isValidNumber();
    }
    return false;
  },
  callMeBackListeners: function (modal) {
    //send button
    const props = bcl.c.cancelationModal.props.callMeFormProps;
    bcl.c.cancelationModal.sendFormButtonListener(modal, props);
    //on change
    bcl.c.cancelationModal.termsOnChangeCallMeBack(modal, props);
  },
  initModalListeners: function (modal, select, reasonsContainer) {
    //close Modal
    bcl.c.cancelationModal.closeModalListener(modal);
    //show call me back Form
    bcl.c.cancelationModal.callMeListener(modal);
    //select onchange
    bcl.c.cancelationModal.selectOnChangeListener(select, reasonsContainer);
    //cancel reservation
    bcl.c.cancelationModal.cancelReservationListener(modal);
    //CallMeBackListeners
    bcl.c.cancelationModal.callMeBackListeners(modal);

    bcl.c.cancelationModal.telOnChangeCallMeBack();
  },

  preInit: function () {
    bcl.u.docReady(bcl.c.cancelationModal.init, true);
  },
};

bcl.preInit.push(bcl.c.cancelationModal.preInit);
